export enum BuyOrSell {
  BUY = 1,
  SELL = 2,
  BOTH = 3,
}

export enum BuyOrSellLabel {
  BUY = 'buy',
  SELL = 'sell',
  BOTH = 'both',
}

export type PriceComponent = {
  id: number | string;
  points: number[];
  description: string;
  nodes: number[];
  buy_sell: BuyOrSellLabel;
};

export type RelatedPriceComponent = {
  id: number;
  description: string;
  buy_sell: BuyOrSell;
};
